import axios from 'axios'
import { ZipAddressRes } from 'types/address'

export const fetchAddressFromPostalCode = async (postalCode: string) => {
  const url = `https://madefor.github.io/postal-code-api/api/v1/${postalCode.slice(0, 3)}/${postalCode.slice(
    3,
    7
  )}.json`
  const res: ZipAddressRes = await axios.get(url)
  return res.data.data
}
